<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Requisition Merge</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submit"
                  ref="addEmployee"
                  id="addEmployee"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="merge_date.value.value"
                        :error-messages="merge_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Merge Date
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-date-input>

                      <v-autocomplete
                        label="Requisition"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="requisition_ids.value.value"
                        :items="getMergeablePurchaseRequisitionList"
                        :item-title="(item) => `${item.code}`"
                        item-value="id"
                        @update:modelValue="onRequisitionChange"
                        :error-messages="requisition_ids.errorMessage.value"
                        autocomplete="off"
                        :loading="selectedRequisitionLoading"
                        multiple
                        chips
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Requisition
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <!-- <v-autocomplete
                        label="Requisition"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="requisition_type.value.value"
                        :items="getRequisitionTypeList()"
                        :item-title="(item) => `${item.label}`"
                        item-value="value"
                        :error-messages="requisition_type.errorMessage.value"
                        autocomplete="off"
                        :loading="loading"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Requisition Type
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete> -->

                      <v-text-field
                        label="Merge By"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="merge_by.value.value"
                        :error-messages="merge_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Merge By Mobile"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="merge_by_mobile.value.value"
                        :error-messages="merge_by_mobile.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Merge By Email"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="merge_by_email.value.value"
                        :error-messages="merge_by_email.errorMessage.value"
                        :disabled="true"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Requisition Merge Product Summary</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form ref="addEmployee" id="addEmployee">
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <v-data-table
                        :headers="headers"
                        :items="cart"
                        density="compact"
                        show-expand
                        :loading="loading"
                        item-key="product_id"
                        class="elevation-1"
                        hide-default-footer
                        :items-per-page="-1"
                      >
                        <!-- Serial Number -->
                        <template v-slot:item.index="{ index }">
                          {{ index + 1 }}
                        </template>

                        <template v-slot:item.product_code="{ item }">
                          {{ item.product_code }}
                        </template>

                        <!-- Product Name -->
                        <template v-slot:item.product_name="{ item }">
                          {{ item.product_name }}
                        </template>

                        <!-- Quantity -->
                        <template v-slot:item.quantity="{ item }">
                          {{ item.quantity }}
                        </template>

                        <!-- Already Merged Qty -->
                        <template v-slot:item.already_merged="{ item }">
                          {{ item.already_merged }}
                        </template>

                        <!-- Input Quantity -->
                        <template v-slot:item.input_quantity="{ item }">
                          <v-text-field
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="item.input_quantity"
                            type="number"
                            hide-details
                            disabled
                            :min="0"
                            :max="item.quantity"
                            style="width: 90px; padding: 5px 0"
                            @update:modelValue="
                              (val) => {
                                if (val > item.quantity)
                                  item.input_quantity = item.quantity;
                                if (val < 0) item.input_quantity = 0;
                              }
                            "
                            :error-messages="
                              item.input_quantity < 1
                                ? 'Quantity must be greater than 0'
                                : ''
                            "
                          ></v-text-field>
                        </template>

                        <!-- Unit -->
                        <template v-slot:item.unit="{ item }">
                          {{ item.unit }}
                        </template>

                        <!-- Actions -->
                        <template v-slot:item.actions="{ index }">
                          <v-icon
                            size="small"
                            color="red"
                            class="delete-button"
                            @click="removeFromCart(index)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>

                        <!-- Expanded Row for Breakdown -->
                        <template v-slot:expanded-row="{ item, columns }">
                          <tr>
                            <td :colspan="columns.length">
                              <v-card flat class="ma-2 pa-2 rounded" color="grey-lighten-4">
                                <div class="text-subtitle-2 text-center text-decoration-underline mb-2">
                                  Requisition Breakdown
                                </div>
                                <v-data-table
                                  :headers="breakdownHeaders"
                                  :items="item.breakdown"
                                  density="compact"
                                  class="elevation-1 pa-2 rounded"
                                  hide-default-footer
                                  :items-per-page="-1"
                                >
                                  <!-- Serial Number -->
                                  <template v-slot:item.sl="{ index }">
                                    {{ index + 1 }}
                                  </template>

                                  <!-- Requisition Code -->
                                  <template v-slot:item.code="{ item: breakdownItem }">
                                    <v-chip color="blue-lighten-1" size="small">
                                      {{ breakdownItem.code }}
                                    </v-chip>
                                  </template>

                                  <!-- Quantity -->
                                  <template v-slot:item.quantity="{ item: breakdownItem }">
                                    {{ breakdownItem.quantity }}
                                  </template>
                                  
                                  <!-- merged quantity  -->
                                  <template v-slot:item.merged_qty="{ item: breakdownItem }">
                                    {{ breakdownItem.merged_qty }}
                                  </template>

                                  <!-- Input Field for Breakdown Quantity -->
                                  <template v-slot:item.breakdown_input="{ item: breakdownItem }">
                                    <v-text-field
                                      density="compact"
                                      variant="outlined"
                                      bg-color="white"
                                      v-model.number="breakdownItem.input_quantity"
                                      type="number"
                                      hide-details
                                      :min="0"
                                      :max="isEntryMode === false ? breakdownItem.quantity : breakdownItem.remaining_qty"
                                      style="width: 90px; padding: 5px 0"
                                      @update:modelValue="val => handleBreakdownInput(breakdownItem, val)"
                                    ></v-text-field>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </td>
                          </tr>
                        </template>

                        <!-- Empty State -->
                        <template v-slot:no-data>
                          <div class="text-center text-red pa-4">
                            You have no items
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-row class="pt-2">
                      <v-col cols="8">
                        <v-textarea
                          label="Description"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="remarks.value.value"
                          :error-messages="remarks.errorMessage.value"
                          autocomplete="off"
                          rows="3"
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="4">
                        <v-layout class="justify-end">
                          <v-btn
                            class="bg-grey-darken-1 me-2"
                            variant="flat"
                            @click="submitForm(0)"
                            >DRAFT</v-btn
                          >
                          <v-btn
                            class="bg-primary"
                            variant="flat"
                            @click="submitForm(1)"
                            >{{ isEntryMode ? "Save" : "Update" }}</v-btn
                          >
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import axios from "axios";
import formattedDate from "@/plugins/dateFormatter";
import { getSelectedPurRequisitionList } from "@/store/api";
import { useRouter } from "vue-router";

export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    errorMessages: "",
    visible: false,
    search: "",
    cart: [],
    selectedRequisitions: [],
    loading: false,
    selectedRequisitionLoading: false,
    isEntryMode: false,
    headers: [
      { title: "SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "Code", align: "left", key: "product_code", sortable: false },
      { title: "Product Name", align: "left", key: "product_name", sortable: false },
      { title: "Quantity", align: "center", key: "quantity", sortable: false },
      { title: "Already Merge Qty", align: "center", key: "already_merged", sortable: false },
      { title: "Input Quantity", align: "center", key: "input_quantity", sortable: false },
      { title: "Unit", align: "center", key: "unit", sortable: false },
      { title: "Action", align: "center", key: "actions", sortable: false },
    ],
    breakdownHeaders: [
      { title: "SL", align: "center", key: "sl", width: "10%" },
      { title: "Requisition Code", align: "center", key: "code" },
      { title: "Quantity", align: "center", key: "quantity" },
      { title: "Merged Qty", align: "center", key: "merged_qty" },
      { title: "Remaining Qty", align: "center", key: "remaining_qty" },
      { title: "Input Quantity", align: "center", key: "breakdown_input" },
    ],
  }),
  watch: {},

  created() {
    // if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch("getHrmDepartmentList");
    // }
    this.selectedRequisitionLoading = true;
    this.$store.dispatch("getMergeablePurchaseRequisitionList").then(() => {
      this.selectedRequisitionLoading = false;
    });
  },

  computed: {
    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getMergeablePurchaseRequisitionList() {
      return this.$store.getters.getMergeablePurchaseRequisitionList.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
  },
  methods: {
    handleBreakdownInput(breakdownItem, val) {
      const maxQty = this.isEntryMode ? breakdownItem.remaining_qty : breakdownItem.quantity;

      if (val > maxQty) breakdownItem.input_quantity = maxQty;
      if (val < 0) breakdownItem.input_quantity = 0;

      const parentItem = this.cart.find(item =>
        item.breakdown.includes(breakdownItem)
      );

      if (parentItem) {
        this.updateParentQuantity(parentItem);
      }
    },

    getRequisitionTypeList() {
      return [
        { value: 'with_cs', label: 'With CS' },
        { value: 'without_cs', label: 'Without CS'},
      ];
    },

    async onRequisitionChange(ids, cncData = null) {
      if (!ids || ids.length === 0) {
        this.selectedRequisitions = [];
        this.cart = [];
        return;
      }
      const data = {
        requisition_ids: ids,
        // requisition_type:this.requisition_type?.value?.value,
        cnc_master_id: this.cnc_master_id.value.value,
        branch_id: this.branchId,
      };
      this.loading = true;
      await axios
        .post(getSelectedPurRequisitionList, data)
        .then((response) => {
          const requisitions = response.data.data;
          this.selectedRequisitions = requisitions;
          this.loading = false;
          this.mergedProducts(cncData);
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error fetching requisitions:", error);
          toast.error("Failed to fetch requisitions.");
        });
    },

    mergedProducts(cncData = null) {
      const productMap = {};
      console.log("Selected Requisitions:", this.selectedRequisitions);
      console.log("CNC Data:", cncData);
      
      // If in EDIT mode, build cart ONLY from saved merge details
      if (cncData && cncData.pur_req_merge_details) {
        console.log("EDIT MODE: Building from pur_req_merge_details");
        
        cncData.pur_req_merge_details.forEach(detail => {
          // Initialize product entry
          if (!productMap[detail.product_id]) {
            productMap[detail.product_id] = {
              product_id: detail.product_id,
              product_name: detail.product.name,
              product_code: detail.product.code,
              quantity: 0,
              already_merged: 0,
              input_quantity: 0,
              rate: detail.rate,
              unit: detail.product.unit.name,
              breakdown: [],
            };
          }

          // Add breakdown ONLY from items that were merged in this CNC
          detail.pur_req_merge_item_detail.forEach(item => {
            const reqQty = parseFloat(item.req_qty);
            const mergeQty = parseFloat(item.merge_qty);
            const requisition = this.selectedRequisitions.find(req => req.id === item.req_mst_id);
            const reqCode = requisition ? requisition.code : `REQ-${item.req_mst_id}`;

            productMap[detail.product_id].quantity += reqQty;
            productMap[detail.product_id].already_merged += (reqQty - mergeQty); // Already merged BEFORE this edit
            productMap[detail.product_id].input_quantity += mergeQty;

            productMap[detail.product_id].breakdown.push({
              requisition_id: item.req_mst_id,
              req_detail_id: item.req_dtls_id,
              code: reqCode,
              quantity: reqQty,
              merged_qty: reqQty - mergeQty, // Previously merged (before this CNC)
              remaining_qty: reqQty - (reqQty - mergeQty), // Available to merge now
              input_quantity: mergeQty, // What was merged in THIS CNC
            });
          });
        });
      } else {
        // ENTRY MODE: Build from all requisition details
        console.log("ENTRY MODE: Building from requisition details");
        
        for (const requisition of this.selectedRequisitions) {
          for (const product of requisition.details) {
            if (!productMap[product.product_id]) {
              productMap[product.product_id] = {
                product_id: product.product_id,
                product_name: product.product_name,
                product_code: product.product_code,
                quantity: 0,
                already_merged: 0,
                input_quantity: 0,
                rate: product.rate,
                unit: product.unit,
                breakdown: [],
              };
            }

            if (product.qty) {
              const remainingQty = product.qty - product.already_merge_qty;
              
              // Only add products that have remaining quantity to merge
              if (remainingQty > 0) {
                productMap[product.product_id].quantity += product.qty;
                productMap[product.product_id].already_merged += product.already_merge_qty;
                productMap[product.product_id].input_quantity += remainingQty;

                productMap[product.product_id].breakdown.push({
                  requisition_id: requisition.id,
                  req_detail_id: product.id,
                  code: requisition.code,
                  quantity: product.qty,
                  merged_qty: product.already_merge_qty,
                  remaining_qty: remainingQty,
                  input_quantity: remainingQty,
                });
              }
            }
          }
        }
      }

      this.cart = Object.values(productMap);
      console.log("Final Cart:", this.cart);
      return Object.values(productMap);
    },

    updateParentQuantity(item) {
      item.input_quantity = item.breakdown.reduce(
        (sum, breakdownItem) => sum + (Number(breakdownItem.input_quantity) || 0), 
        0
      );
    },

    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        merge_date: yup.date().required().label("Merge Date"),
        requisition_ids: yup
          .array()
          .of(yup.number().positive().integer())
          .min(1, "At least one requisition is required")
          .required()
          .label("Selected Requisitions"),
        // requisition_type:yup.string().required().label("Selected Requisition Type"),
        department_id: yup.number().positive().integer().nullable().label("Department Name"),
      }),
    });

    const merge_date = useField("merge_date");
    const product_id = useField("product_id");
    const pr_status = useField("pr_status");
    const employee_id = useField("employee_id");
    const department_id = useField("department_id");
    const requisition_ids = useField("requisition_ids");
    // const requisition_type = useField("requisition_type");
    const cnc_master_id = useField("cnc_master_id");
    const remarks = useField("remarks");
    const merge_by = useField("merge_by");
    const merge_by_mobile = useField("merge_by_mobile");
    const merge_by_email = useField("merge_by_email");
    const errorMessages = ref("");
    const selectedRequisitions = ref([]);
    const cart = ref([]);
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();

    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      values.pr_status = currentStatus.value;
      values.cart = cart.value;
      values.merge_date = formattedDate(merge_date.value.value);
      store
        .dispatch("saveUpdatePurRequisitionMerge", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "cnc-merge-record" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submitForm,
      submit,
      product_id,
      merge_date,
      remarks,
      cart,
      selectedRequisitions,
      merge_by,
      merge_by_mobile,
      merge_by_email,
      pr_status,
      errorMessages,
      employee_id,
      department_id,
      requisition_ids,
      // requisition_type,
      cnc_master_id,
      buttonText,
    };
  },

  mounted() {
    // Default values
    this.pr_status.value.value = "1";
    this.employee_id.value.value = "";

    // Set logged-in user info
    const user = this.$store.getters.getAuthUser;
    this.merge_by.value.value = user?.full_name || "";
    this.merge_by_mobile.value.value = user?.mobile || "";
    this.merge_by_email.value.value = user?.email || "";

    // Check if editing
    const id = this.$route.query.id;
    if (id) {
      this.isEntryMode = false;
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$store
        .dispatch("getPurRequisitionMergeById", id)
        .then(async (data) => {
          const cnc = data;
          if (cnc) {
            this.cnc_master_id.value.value = cnc.id;
            this.merge_date.value.value = cnc.merge_date;
            const requisitionIds = cnc.requisition_ids
              ? cnc.requisition_ids.split(",").map((id) => Number(id))
              : [];
            this.requisition_ids.value.value = requisitionIds;
            // this.requisition_type.value.value = cnc.requisition_type;
            this.remarks.value.value = cnc.remarks || "";
            this.pr_status.value.value = cnc.pr_status?.toString() || "1";

            // Fetch requisition data with breakdown and pass cnc data
            if (requisitionIds.length > 0) {
              await this.onRequisitionChange(requisitionIds, cnc);
            }
          }
          this.$store.commit("UNSET_LOADING");
        })
        .catch((error) => {
          console.error("Failed to fetch requisition merge:", error);
          this.$store.commit("UNSET_LOADING");
        });
    } else {
      // Fresh entry mode
      this.isEntryMode = true;
      this.cnc_master_id.value.value = "";
      this.merge_date.value.value = new Date();
      this.remarks.value.value = "";
      this.cart = [];
    }
  },
};
</script>